export const landingMetaRoutes = [
  {
    path: '/landing-meta',
    lazy: async () => {
      const { LandingRoute } =
        await import('../Landing/LandingRoute/LandingRoute');
      return { Component: LandingRoute };
    },
  },
  {
    path: '/landing-meta/login',
    lazy: async () => {
      const { LoginRoute } = await import('./Login/Login');
      return { Component: LoginRoute };
    },
  },
  {
    path: '/landing-meta/register',
    lazy: async () => {
      const { RegisterRoute } = await import('./Register/Register');
      return { Component: RegisterRoute };
    },
  },
  {
    path: '/landing-meta/forgot-password',
    lazy: async () => {
      const { LandingForgotPasswordRoute } =
        await import('./ForgotPassword/ForgotPassword');
      return { Component: LandingForgotPasswordRoute };
    },
  },
];

export const protectedLandingMetaRoutes = [
  {
    path: '/landing-meta',
    lazy: async () => {
      const { LandingRoute } =
        await import('../Landing/LandingRoute/LandingRoute');
      return { Component: LandingRoute };
    },
  },
  {
    path: '/landing-meta/plan',
    lazy: async () => {
      const { PlanRoute } = await import('./Plan/Plan');
      return { Component: PlanRoute };
    },
  },
];
